export const categories = [
    { label: '单景区', value: 61 },
    { label: '水上乐园', value: 62 },
    { label: '动物园', value: 272 },
    { label: '植物园', value: 273 },
    { label: '温泉', value: 276 },
    { label: '游乐场/主题乐园', value: 59 },
    { label: '海洋馆', value: 271 },
    { label: '博物馆/美术馆/科技馆', value: 64 },
    { label: '游船', value: 270 },
    { label: '高空观景', value: 67 },
    { label: '漂流', value: 278 },
    { label: '巴士观光', value: 269 },
    { label: '滑雪', value: 283 },
    { label: '演出票', value: 760 },
    { label: '餐/票+餐', value: 776 },
    { label: '物流商品', value: 779 },
    // {label: '骑马', value: 88},
    // {label: '滑冰', value: 284},
    { label: '其他', value: 274 }
]

export const usePeopleTypes = [
    { label: '成人票', value: 1 },
    { label: '儿童票', value: 2 },
    { label: '老人票', value: 3 },
    { label: '双人票', value: 4 },
    { label: '不限人群票', value: 5 },
    { label: '亲子票', value: 6 },
    { label: '学生票', value: 7 },
    { label: '优待票', value: 8 },
    { label: '团体票', value: 9 },
    { label: '三人票', value: 10 },
    { label: '其他', value: 0 }
]

export const timeLimitedRangeTypes = [
    { label: '平日', value: 1 },
    { label: '周末', value: 2 },
    { label: '不限时间', value: 3 },
    { label: '其他', value: 0 }
]

export const uploadMaterialTypes = [
    { label: '无需上传物料类型', value: 0 },
    { label: '文本', value: 1 },
    { label: '图片', value: 2 },
    { label: '文本+图片', value: 3 }
]

export const buyCountLimitTypes = [
    {label:'张', value: 0},
    {label:'单', value: 1}
];

export const textareaForbiddenWords = [
    '营业时间',
    '入园时间',
    '预约',
    '预定',
    '预订',
    '电话',
    '有效期'
]

export const ticketName2PersonType = {
    '儿童票': ['儿童'],
    '老人票': ['老年人'],
    '亲子票': ['儿童'],
    '学生票': ['全日制大中小学生(不含成人教育、研究生)', '全日制大中小学生'],
    '优待票': ['残疾人', '现役军人', '离休干部', '教师']
}



// WEBPACK FOOTER //
// ./src/data/ticket.js